<style>
.tooltip {
  opacity: 1 !important;
  background-color: rgb(0, 0, 2);
  color: white;
}
</style>

<template>
  <div class="loan">
    <!-- Spinner -->
    <div style="position: fixed; top: 50%; left: 50%; z-index: 999;">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>

    <!-- Error Notification -->
    <div class="mb-3" v-if="processingError">
      <va-notification color="danger" closeable>
        An error occurred! Please try again later.
      </va-notification>
    </div>


    <div class="row">
      <div class="flex s12 md9">
        <va-card>
         
          <div class="d-flex justify-space-between align-center mb-3">
            <h4 class="va-h4 mb-0">{{ $t('loans.myappliedloans') }}</h4>
            <va-button icon="fa fa-close" @click="$router.go(-1)">
              {{ $t('Cancel') }}
            </va-button>
          </div>

          <!-- Search Field -->
          <va-input
            class="ma-0"
            :value="term"
            :placeholder="$t('tables.searchByName')"
            @input="search"
            removable
          >
            <va-icon name="fa fa-search" slot="prepend" />
          </va-input>

          <!-- Data Table -->
          <va-data-table
            :fields="mode ? detailedFields : fields"
            :data="filteredData"
            :per-page="10"
            hoverable
          >
            <template slot="icon">
              <va-icon name="fa fa-list" color="secondary" />
            </template>

            <template v-slot:checkoffNo="props">
              {{ props.rowData.checkoffNo }}
            </template>

            <template v-slot:amount="props">
              {{ props.rowData.amount | Currency }}
            </template>

            <template v-slot:postdate="props">
              {{ props.rowData.postdate }}
            </template>

            <template v-slot:details="props">
              <va-button @click="moreDetails(props.rowData.checkoffNo, props.rowData.postdate)">
                {{ $t('More') }}
              </va-button>
            </template>
          </va-data-table>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script src="https://unpkg.com/vue@2.5.13/dist/vue.js"></script>
<script>

import axios from 'axios'
import * as spinners from 'epic-spinners'

export default {
  
  components: {
    ...spinners      
  },
  name: 'loan',
  name: 'App',
  data () {
    return {
      userData: JSON.parse(localStorage.getItem('LoggedUser')),
      accdetails: JSON.parse(localStorage.getItem('UserMianFosa')),
      token: JSON.parse(localStorage.getItem('Token')),   
      loan_no : this.$route.params.loan_no,
      loading: false,
      term: null,
      loadSelect:false,
      processingError: false,
      payment_method : '',
      finalPost : '',
      details:{},
      formdata:{
        phone_no:'',
        loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        grossSalary:'',
        user: '',
        
      },
      montlyrepayment:'',
      loanType:'',
        LoanapplicationNo:'',
        appliedamount:'',
        AmountGuarantee:'',
        ApprovalStatus:'',
        repaymentperiod:'',
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      }     
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },

fields () {
      return [{
        name: '__slot:icon',
        width: '30px',
        dataClass: 'text-center',
      }, {
        name: '__slot:checkoffNo',
        title: this.$t('Checkoff Number'),
        width: '30%',
        sortField: 'amount',
      }, 
      {
        name: '__slot:amount',
        title: this.$t('Amount'),
        width: '20%',
        sortField: 'amount',
      },
      {
        name: '__slot:postdate',
        title: this.$t('Posted Date'),
        width: '20%',
        sortField: 'Date',
      },
      {
        name: '__slot:details',
        title: this.$t(''),
        width: '20%',
        sortField: 'details',
      },
    ]
    },
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.details
      }
      console.log(this.term);
      return this.details.filter(item => {
        return item.description.toLowerCase().startsWith(this.term.toLowerCase()) || item.amount.toLowerCase().startsWith(this.term.toLowerCase())
      })
    },
    formReady () {

     },      
  },
  methods : {
    GetProduct(id) {      
      return this.loans.filter(item => item.loanType.toLowerCase() === this.id.toLowerCase());      
    },
    
 
    onsubmit () {

    },


    GetgeneralCheckoff () {
      this.loadSelect = true
      this.loading = true
      const self = this
      const form = {
  user:this.userData.user_id,
  phonenumber: this.userData.mobile_number
      }
      let config = {
        headers: {
          Authorization: this.userData.user_id+' '+this.token
        }
      }
      axios.post(`${self.$apiUrl}checkoffMain`, form, config)
      .then(function (res) {

          self.loadSelect = false
          self.loading = false
          res = res.data
          self.details = res.slice()

      })
      .catch(function (error) {
          console.log(error)
      })
    },

    moreDetails (checkoffNo, postdate ) {
      console.log(checkoffNo);
      console.log(postdate);
      this.$router.push({name: 'checkoff-details', params: { checkoffNo:checkoffNo, postdate:postdate }});
},
  },
  created () { 
    this.GetgeneralCheckoff();
   
 
  }
}
</script>